import { MAX_IMAGE_SIZE } from '@showbie-socrative/socrative-utils';

interface IsValidImageSizeParams {
  file: File;
  maxFileSize?: number;
}

export function isValidImageSize({
  file: { size },
  maxFileSize = MAX_IMAGE_SIZE,
}: IsValidImageSizeParams) {
  return size <= maxFileSize;
}

export class InvalidImageSizeError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'InvalidImageSizeError';
  }
}
